// removed by extract-text-webpack-plugin
module.exports = {"flex":"CoreLayout__flex___wvH7-","flex-column":"CoreLayout__flex-column___HGyul","flex-column-center":"CoreLayout__flex-column-center___3xCaT","flex-row":"CoreLayout__flex-row___3zIAE","flex-row-center":"CoreLayout__flex-row-center___2cRy3","container":"CoreLayout__container___31Gy2","children":"CoreLayout__children___2zncu"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.scss
// module id = 1072
// module chunks = 2